"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCDownIcon16Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCDownIcon16Solid = forwardRef_1.forwardRef('ArrowCDownIcon16Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.616 5.116a1.25 1.25 0 0 1 1.768 0L8 8.732l3.616-3.616a1.25 1.25 0 0 1 1.768 1.768L9.59 10.677a2.25 2.25 0 0 1-3.182 0L2.616 6.884a1.25 1.25 0 0 1 0-1.768Z" })));
});
